<div class="embed-container" provide-parent-form>
	<embed-preview class="contents"
		[playlist]="playlist"
		[configuration]="{standAlone: true, autoPlay: false, alwaysShow: false, showVideo: false}"
		[isActive]="isActive"
		[form]="form"
		name="embed-preview"
		(onPlayoutChange)="onPlayoutChanged($event)">
	</embed-preview>
</div>
